/**
 * The bold first line of the Success and Pending toasts: one line, ellipsis
 * when it overflows. Error and Warning toasts wrap theirs instead.
 */
export const toastMainLineClassName =
  "box-border max-w-[320px] overflow-hidden overflow-ellipsis whitespace-nowrap font-semibold"

/**
 * An item or drop name followed by more text on the toast's first line
 * ("… is yours", "… for 0.005 SOL"). Names wider than 40% of the line end in
 * an ellipsis, leaving room for the text after them; on narrow screens or with
 * long prices the line's own ellipsis can still cut that text. Hovering shows
 * the whole name.
 */
export function ToastItemName({ name }: { name: string }) {
  return (
    <span
      title={name}
      className="inline-block max-w-[40%] truncate align-bottom"
    >
      {name}
    </span>
  )
}
